

























































/* ----------------------------------------
    Imports
---------------------------------------- */

import { Prop, Component } from 'vue-property-decorator';
import FormInput from './Input.vue';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    data() {
        return {
            showPasswordProxy: null,
        }
    },

    created() {
        this.showPasswordProxy = this.showPassword;
    },

    computed: {
        cPasswordType() {
            return (this.showPasswordProxy) ? 'text' : 'password';
        }
    },

    methods: {
        toggleType() {
            this.showPasswordProxy = !this.showPasswordProxy;
        }
    }
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class FormInputPassword extends FormInput {
    @Prop({ type: Boolean, default: false }) showPassword: boolean
}

